import React from 'react'
import {Transition, animated} from 'react-spring/renderprops'
import roles from '../../roles'
import {Consumer} from '../../context'
import './page.styl'

function animatedPage (Elem, page) {
  return style => (
    <animated.div style={style} className={`page ${page}`}>
      <Elem />
    </animated.div>
  )
}

function Page () {
  return (<Consumer>{ ({page, role}) => {
    const pages = roles[role]
    return (
      <Transition
          native
          reset
          unique
          items={page}
          from={{position: 'absolute', opacity: 0}}
          enter={{opacity: 1}}
          leave={{opacity: 0}}>
          {index => pages[index]}
        </Transition>
    )
  }}</Consumer>)
}

export {Page as default, animatedPage}
